import React from 'react';
import { Globe2, ThumbsDown, ThumbsUp, ShieldCheck } from 'lucide-react';
import { Ticket } from '../../lib/types';
import { Textarea } from '../ui/textarea';
import { TriageSummary } from './TriageSummary';
import { DraftActions, DraftActionProps } from './DraftActions';

function saveStatus(ticket: Ticket, draft: string): string {
  if (draft !== ticket.draft) return 'Unsaved changes';
  if (ticket.approved_at) return 'Human-approved reply';
  if (ticket.cached) return 'Retrieved from saved draft cache';
  return 'Ready for your review';
}

const DraftFeedback = ({ticket, saving, onPatch}: Pick<DraftActionProps, 'ticket' | 'saving' | 'onPatch'>) => <div>
  <button className={`icon-button ${ticket.feedback === 'up' ? 'selected' : ''}`} title="Helpful draft" aria-label="Helpful draft" aria-pressed={ticket.feedback === 'up'} disabled={saving} data-testid="feedback-thumbs-up-button" onClick={() => onPatch({feedback: 'up'})}><ThumbsUp size={15}/></button>
  <button className={`icon-button ${ticket.feedback === 'down' ? 'selected' : ''}`} title="Needs improvement" aria-label="Needs improvement" aria-pressed={ticket.feedback === 'down'} disabled={saving} data-testid="feedback-thumbs-down-button" onClick={() => onPatch({feedback: 'down'})}><ThumbsDown size={15}/></button>
</div>;

export const DraftEditor = (props: DraftActionProps & {setDraft: (draft: string) => void}) => {
  const {ticket, draft, saving, setDraft, onPatch} = props;
  return <div className="draft-content">
    <TriageSummary ticket={ticket} saving={saving} onPatch={onPatch}/>
    <div className="editor-label"><span data-testid="reply-label">DRAFT REPLY</span><span data-testid="reply-language"><Globe2 size={12}/>{ticket.language}</span></div>
    <Textarea data-testid="ai-draft-reply-textarea" aria-label="Draft reply" className="draft-textarea" value={draft} onChange={event => setDraft(event.target.value)} disabled={ticket.status === 'resolved' || saving} placeholder="Write a reply for your customer…" maxLength={16000}/>
    <div className="editor-meta"><span data-testid="draft-save-status" aria-live="polite">{saveStatus(ticket, draft)}</span><DraftFeedback ticket={ticket} saving={saving} onPatch={onPatch}/></div>
    <DraftActions {...props}/>
    <div className="human-note"><ShieldCheck size={13}/><span data-testid="no-auto-send-note">Copied, never sent automatically.</span></div>
  </div>;
};